import { useEffect, useState } from 'react'
import { getProduct } from '@/lib/api'
import type { Perfume } from '@/types'

export function useProduct(slug: string | undefined) {
  const [product, setProduct] = useState<Perfume | undefined | null>(undefined)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let mounted = true
    if (!slug) {
      setLoading(false)
      setProduct(null)
      return
    }
    setLoading(true)
    getProduct(slug)
      .then((p) => {
        if (!mounted) return
        setProduct(p ?? null)
        setError(null)
      })
      .catch((err) => {
        if (!mounted) return
        setError(err instanceof Error ? err.message : 'Failed to load product')
      })
      .finally(() => {
        if (mounted) setLoading(false)
      })
    return () => {
      mounted = false
    }
  }, [slug])

  return { product, loading, error }
}
